import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import AttachmentPreviewModal from '../AttachmentPreviewModal';

const { Text } = Typography;

function normalizeAttachmentItem(item) {
  if (!item) return null;
  if (typeof item === 'string') {
    let path = item.trim();
    if (!path.startsWith('/uploads/')) {
      if (path.startsWith('/admin/contract-approval-files/')) path = `/uploads${path}`;
      else if (path.startsWith('admin/contract-approval-files/')) path = `/uploads/${path}`;
      else if (path.startsWith('expense/')) path = `/uploads/${path}`;
    }
    const name = path.split('/').pop() || '附件';
    return { path, name: decodeURIComponent(name) };
  }
  const path = item.path || item.file_path;
  if (path) {
    const name = item.name || item.file_name || path.split('/').pop() || '附件';
    return { path, name };
  }
  return null;
}

function shortFileLabel(name, maxLen = 10) {
  const text = String(name || '附件').trim();
  if (text.length <= maxLen) return text;
  const extMatch = text.match(/(\.[^.]+)$/);
  const ext = extMatch ? extMatch[1] : '';
  const baseMax = Math.max(4, maxLen - ext.length - 1);
  return `${text.slice(0, baseMax)}…${ext}`;
}

export default function CompactTableAttachments({ attachments = [] }) {
  const [previewItem, setPreviewItem] = useState(null);
  const [listOpen, setListOpen] = useState(false);
  const items = (attachments || []).map(normalizeAttachmentItem).filter(Boolean);
  if (!items.length) return '—';

  if (items.length === 1) {
    const item = items[0];
    return (
      <>
        <Button
          type="link"
          size="small"
          className="finance-table-attachment-link"
          icon={<EyeOutlined />}
          onClick={() => setPreviewItem(item)}
        >
          <Text ellipsis={{ tooltip: item.name }} className="finance-table-attachment-text">
            {shortFileLabel(item.name)}
          </Text>
        </Button>
        <AttachmentPreviewModal
          item={previewItem}
          open={Boolean(previewItem)}
          onClose={() => setPreviewItem(null)}
        />
      </>
    );
  }

  return (
    <>
      <Button
        type="link"
        size="small"
        className="finance-table-attachment-link"
        icon={<EyeOutlined />}
        onClick={() => setListOpen(true)}
      >
        {items.length} 个附件
      </Button>
      <Modal
        title="选择附件预览"
        open={listOpen}
        onCancel={() => setListOpen(false)}
        footer={null}
        width={420}
        destroyOnHidden
      >
        <ul className="seal-approval-attachments-list">
          {items.map((item) => (
            <li key={item.path}>
              <Button
                type="link"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => {
                  setListOpen(false);
                  setPreviewItem(item);
                }}
              >
                <Text ellipsis={{ tooltip: item.name }} style={{ maxWidth: 320 }}>
                  {item.name}
                </Text>
              </Button>
            </li>
          ))}
        </ul>
      </Modal>
      <AttachmentPreviewModal
        item={previewItem}
        open={Boolean(previewItem)}
        onClose={() => setPreviewItem(null)}
      />
    </>
  );
}
